module.exports = __webpack_public_path__ + "img/Apoptosis-BRCA_10X_WTA.be44e7d1.png";